export default __webpack_public_path__ + "static/media/jeadee_img5.746c45f5.webp";